// extracted by mini-css-extract-plugin
export default {"cardMain":"Card_cardMain__bPzZP","cardmageWrapper":"Card_cardmageWrapper__R+O7L"};